import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { LAYER } from '@doltech/utils/lib/constants';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const SCROLLBAR_WIDTH = 14;

const BottomArea = styled.div`
  position: fixed;
  right: ${SCROLLBAR_WIDTH / 2}px;
  bottom: 0;

  display: grid;
  grid-template-columns: minmax(0, 712px);
  justify-content: center;
  pointer-events: none;

  width: 100%;
  opacity: 0;
  z-index: -1;
  transition: all 0.01s ease-out;

  &.visible {
    opacity: 1;
    z-index: ${LAYER.LAYER3};
  }
`;

const StickySidebar = styled.div`
  position: sticky;
  top: 120px;
`;

const MainContent = styled.div``;

const RightSidebar = styled.div`
  position: relative;
  top: 210px;
`;

const LeftSidebar = styled.div`
  position: relative;
  top: 210px;
`;

const Container = styled.div`
  position: relative;

  display: grid;
  grid-template-columns: minmax(0, 712px);
  justify-content: center;
  column-gap: 36px;

  padding-bottom: 80px;

  ${fromScreen(1240)} {
    grid-template-columns: minmax(204px, 320px) 712px minmax(204px, 320px);
  }
`;

interface BlogPageLayoutBodyProps {
  leftSidebar?: React.ReactNode;
  rightSidebar?: React.ReactNode;
  children?: React.ReactNode;
  bottomAction?: React.ReactNode;
  bottomActionVisible?: boolean;
}

export const BlogPageLayoutBody = (props: BlogPageLayoutBodyProps) => {
  const {
    leftSidebar,
    rightSidebar,
    children,
    bottomAction,
    bottomActionVisible = false
  } = props;

  return (
    <Container className="blog-page-layout-body">
      <LeftSidebar className="left-sidebar">
        <StickySidebar>
          {leftSidebar}
        </StickySidebar>
      </LeftSidebar>
      <MainContent>
        {children}
      </MainContent>
      <RightSidebar className="right-sidebar">
        <StickySidebar>
          {rightSidebar}
        </StickySidebar>
      </RightSidebar>
      {bottomAction && (
        <BottomArea className={cl('bottom-area', { visible: bottomActionVisible })}>
          {bottomAction}
        </BottomArea>
      )}
    </Container>
  );
};
